import {
    FinancialCondition,
    FinancialConditionCreateDto,
    FinancialConditionUpdateDto,
} from 'types/financial-conditions';
import { portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIFinancialConditionsSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['FinancialConditions', 'Companies', 'CompaniesMin'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getFinancialConditionById: builder.query<FinancialCondition, string>({
                query: (entityId) => `/v1/financial-conditions/${entityId}`,
                keepUnusedDataFor: 0,
            }),
            getFinancialConditionsList: builder.query<FinancialCondition[], void>({
                query: () => '/v1/financial-conditions',
                providesTags: ['FinancialConditions'],
            }),
            getFinancialConditionsWithFilters: accumulatedQueryWithFilters<FinancialCondition>(
                builder,
                '/v1/financial-conditions',
                {
                    providesTags: ['FinancialConditions'],
                }
            ),
            addFinancialCondition: builder.mutation<FinancialCondition, FinancialConditionCreateDto>({
                query: ({ ...body }) => ({
                    url: `/v1/financial-conditions`,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: ['FinancialConditions', 'Companies', 'CompaniesMin'],
            }),
            updateFinancialCondition: builder.mutation<FinancialCondition, FinancialConditionUpdateDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/financial-conditions/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: (_1, _2, arg) =>
                    arg.id
                        ? [
                              'FinancialConditions',
                              { type: 'FinancialConditions', id: arg.id },
                              'Companies',
                              'CompaniesMin',
                          ]
                        : ['FinancialConditions', 'Companies', 'CompaniesMin'],
            }),
            deleteFinancialCondition: builder.mutation<boolean, { entityId: string }>({
                query: ({ entityId }) => ({
                    url: `/v1/financial-conditions/${entityId}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['FinancialConditions'],
            }),
        }),
        overrideExisting: false,
    });

export const { useAddFinancialConditionMutation, useUpdateFinancialConditionMutation } = APIFinancialConditionsSlice;
